import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate as t } from "../../../../infrastructure/translate/localization";
import ButtonAction from "../../../../app/components/commons/buttonAction/ButtonAction";

import editEmployeesImg from "../../../../assets/img/edit-employees.svg";

import "./upload-card.scss";

class UploadCard extends Component {
  render() {
    const { uploading, uploadFile } = this.props;
    return (
      <div className="section-container upload-csv-card">
        <p className="title">{t("edit-employees.edit-employees-upload")}</p>
        <div className="upload-csv-card-content">
          <div className="thumbnail center">
            <img
              src={editEmployeesImg}
              alt={t("edit-employees.edit-employees-upload")}
            />
          </div>
          <div className="upload-csv-card-content-description">
            <p>{t("edit-employees.edit-employees-upload-description")}</p>
            <ul className="list-info-card">
              <li className="list-info-card-item">
                {t("edit-employees.edit-employees-upload-info-1")}
              </li>
              <li className="list-info-card-item">
                {t("edit-employees.edit-employees-upload-info-2")}
              </li>
            </ul>
          </div>
        </div>
        <div className="buttons-group">
          <ButtonAction
            textButton={t("upload-employees-section.upload-csv")}
            loading={uploading}
            textLoadingButton={t("common-messages.loading-data")}
            handlerClick={() => this.upload.click()}
          />
          <input
            id="workaround-upload"
            accept="text/csv"
            type="file"
            ref={(ref) => {
              this.upload = ref;
            }}
            style={{ display: "none" }}
            onChange={(e) => uploadFile(e)}
          />
        </div>
      </div>
    );
  }
}

UploadCard.defaultProps = {
  uploading: false,
};

UploadCard.propTypes = {
  uploading: PropTypes.bool,
  uploadFile: PropTypes.func.isRequired,
};

export default UploadCard;
